import { storageHandler } from "../../Helpers";
import { ROUTES } from "./routesConstant";

import { Handshake, ShoppingCart, LayoutDashboardIcon, List, Megaphone, MessagesSquare, Navigation, ThumbsUp, Rocket, HandCoins, ScrollText, ChartNoAxesCombined, GalleryVerticalEnd, BookOpenCheck, UserRoundPen, BookImage, TrainFrontTunnel, ScreenShare, MessageCircleQuestionMark, ShieldAlert, DatabaseBackup } from "lucide-react";

export const BrandNav = [
  { title: "Dashboard", url: ROUTES.BRAND.DASHBOARD, icon: LayoutDashboardIcon },
  { title: "Campaigns", url: ROUTES.BRAND.JOB_CAMPAIGNS, icon: Rocket },
  {
    title: "Explore Influencer",
    url: ROUTES.BRAND.EXPLORE_INFLUENCER,
    icon: Navigation,
  },
  { title: "Influencer List", url: ROUTES.BRAND.INFLUENCER_LIST, icon: List },
  { title: "Orders", url: ROUTES.BRAND.ORDERS, icon: ShoppingCart },
  { title: "Offers", url: ROUTES.BRAND.OFFERS, icon: HandCoins },
  { title: "Messages", url: ROUTES.BRAND.MESSAGES, icon: MessagesSquare },
  { title: "Assets", url: ROUTES.BRAND.ASSETS, icon: GalleryVerticalEnd },

  { title: "Campaign Analytics", url: ROUTES.BRAND.REPORTS, icon: ChartNoAxesCombined },

  { title: "TAMA AI Agent", url: ROUTES.BRAND.ASK_TAMA_AGENT, image: `${process.env.PUBLIC_URL}/images/Owl_image.jpg` },

  {
    title: "Recommendations",
    url: ROUTES.BRAND.RECOMMENDATIONS,
    icon: ThumbsUp,
  },



  {
    title: "Brief Generator",
    url: ROUTES.BRAND.BRIEF_GENERATOR,
    icon: ScrollText,
  },
  { title: "Fake Detection Tool", url: ROUTES.BRAND.FRAUD_DETECTION_TOOLS, icon: ShieldAlert },
  {
    title: "Book Training",
    url: ROUTES.BRAND.BOOK_TRAINING,
    externalUrL: "https://calendly.com/darshana-munde/30min?month=2025-08",
    icon: BookOpenCheck,
  },
  { title: " Tama Coins", url: ROUTES.BRAND.TAMA_COINS, icon: ScreenShare },
  {
    title: "Enterprise Campaigns",
    url: ROUTES.BRAND.DIRECT_CAMPAIGNS,
    icon: Megaphone,
  },
];

export const InfluencerNav = [
  { title: "Dashboard", url: ROUTES.INFLUENCER.INFLUENCER_DASHBOARD, icon: LayoutDashboardIcon },
  { title: "Rate & Media Kit", url: ROUTES.INFLUENCER.RATE_MEDIA_KITS, icon: ShoppingCart },
  { title: "Public Profile", url: ROUTES.INFLUENCER.PUBLIC_PROFILE, icon: UserRoundPen },
  { title: "Gallery", url: ROUTES.INFLUENCER.GALLERY, icon: BookImage },
  { title: "Opportunities", url: ROUTES.INFLUENCER.OPPORTUNITIES, icon: Handshake },
  { title: "Collaborations", url: ROUTES.INFLUENCER.INFLUENCER_OFFERS, icon: HandCoins },
  { title: "Messages", url: ROUTES.INFLUENCER.CHAT, icon: MessagesSquare },
  { title: "Refer a Friend", url: ROUTES.INFLUENCER.REFER_A_MEDIA, icon: TrainFrontTunnel },
  { title: "TAMA Blog", url: ROUTES.INFLUENCER.TAMA_BLOG, icon: ScreenShare, externalUrL: "https://blog.tamayou.com/" },
  { title: "Contact Us", url: ROUTES.INFLUENCER.CONTACT_US, icon: MessageCircleQuestionMark, externalUrL: "https://tamayou.com/contact" },

];

export const AdminNav = [
  { title: "Home", url: ROUTES.ADMIN.ADMIN_DASHBOARD, icon: LayoutDashboardIcon },
  { title: "Profile", url: ROUTES.ADMIN.ADMIN_PROFILE, icon: UserRoundPen },
  { title: "Content", url: ROUTES.ADMIN.CONTENT, icon: Navigation },
  { title: "Campaigns", url: ROUTES.ADMIN.ADMIN_CAMPAIGNS, icon: Rocket },
  { title: "Post Verification", url: ROUTES.ADMIN.POST_VERIFICATION, icon: ThumbsUp },
  { title: "Notifications", url: ROUTES.ADMIN.NOTIFICATIONS, icon: MessagesSquare },
  { title: "Users", url: ROUTES.ADMIN.USERS, icon: List },
  { title: "SignUp Url", url: ROUTES.ADMIN.SIGNUP_URL, icon: BookOpenCheck },
  { title: "Tama Coin", url: ROUTES.ADMIN.TAMA_COIN, icon: HandCoins },
  { title: "Flush Cache", url: ROUTES.ADMIN.FLUSH_CACHE, icon: ShoppingCart },
  { title: "Cron", url: ROUTES.ADMIN.CRON_JOBS, icon: Handshake },
  { title: "Data Collection", url: ROUTES.ADMIN.DATA_COLLECTION, icon: DatabaseBackup },

];


export const getHeaderTitle = (pathname, customTitle = null) => {
  // console.log("🚀 ~ getHeaderTitle ~ pathname:", pathname)
  // If custom title is provided, use it
  if (customTitle) {
    return customTitle;
  }

  const cleanedPath = pathname.replace(/\/$/, ""); // remove trailing slash
  const lastSegment = cleanedPath.substring(cleanedPath.lastIndexOf("/") + 1);
  const urlParams = new URLSearchParams(window.location.search);

  // 🔹 Special condition: if pathname includes "brand/owl"
  if (pathname.toLowerCase().includes("brand/owl")) {
    return "Ask Tama Agent";
  }

  if (pathname.includes("brand/influencerProfile")) {
    return "Influencer Profile";
  }

  // 🔹 Special condition: if pathname includes "application"
  if (pathname.toLowerCase().includes("application")) {
    return "Applications";
  }

  if (pathname.includes("orderDetails")) {
    return "Order Details";
  }

  // 🔹 Dynamic titles for campaigns based on URL params or hash
  if (lastSegment === "jobpostbrief") {
    const mode = urlParams.get("mode") || window.location.hash.replace("#", "");
    const isEditMode = window.history.state?.usr?.isEditMode;
    if (mode === "create" || isEditMode === false) return "Create Campaign";
    if (mode === "edit" || isEditMode === true) return "Edit Campaign";
    return "Campaigns";
  }

  const routeMap = {
    dashboard: "Dashboard",
    profile: "My Info",
    billing: "Billing",
    settings: "Settings",
    jobCampaigns: "Campaigns",
    recommendations: "Recommendations",
    campaigns: "Smart Campaigns",
    influencerdiscovery: "Explore Influencers",
    influencerlist: "Influencer List",
    orders: "Orders",
    offers: "Direct Offers",
    chat: "Messages",
    briefing: "Brief Generator",
    owl: "Ask Tama Agent",
    reports: "Reports",
    assets: "Assets",
    booktraining: "Book Training",
    gallery: "Gallery",
    social_accounts: "Rate & Media Kit",
    opportunities: "Opportunities",
    refer_friend: "Refer a Friend",
    pricing: "Pricing",
    content: "Content",
    postverification: "Post Verification",
    notifications: "Notifications",
    tamacoin: "Tama Coin",
    flush: "FlushCache",
    cron: "Cron Details",
    "admin-users": "Manage users",
    "admin-custom-url": "SignUp Url",
    influencerProfile: "Influencer Profile",
    frauddetectiontools: "Fraud Detection Tools",
    datacollection: "Data Collection",
    handlePost: "Handle Post",
    payment: "Payment history",
    publicprofile: "Public Profile",
    brandpage: "Brand Profile",
    placeorder: "Place Order",
    jobpostmain: "Campaigns",
    jobpostdescription: "Campaigns",
    jobpostbrief: "Campaigns",
  };

  return routeMap[lastSegment] || "Dashboard";
};


export const UserInitialName = (
  first,
  second
) => {
  if (!first) return "";
  if (!second) return first[0].toUpperCase();
  return first[0].toUpperCase() + second[0].toUpperCase();
};

export function decodeFromBase64(base64) {
  try {
    const decoded = decodeURIComponent(escape(atob(base64)));
    return JSON.parse(decoded);
  } catch (e) {
    return decodeURIComponent(escape(atob(base64)));
  }
}

export function parseToJson(responseString) {
  try {
    return JSON.parse(responseString);
  } catch (error) {
    console.error("Invalid JSON string:", error);
    return null;
  }
}

export function isBase64(str) {
  const base64Regex = /^(?:[A-Z0-9+\/]{4})*(?:[A-Z0-9+\/]{2}==|[A-Z0-9+\/]{3}=)?$/i;
  return base64Regex.test(str);
}



export function parseInput(input) {
  try {
    if (isBase64(input)) {
      // Base64 decode
      const decoded = decodeFromBase64(input);
      return JSON.parse(decoded);
    } else {
      // Not Base64 → maybe JSON
      return JSON.parse(input);
    }
  } catch (err) {
    console.error("Failed to parse input:", err);
    return null;
  }
}


// Common utility function to get user data
export function getUserData() {
  let data = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }
  return data;
}

// Common utility function to check if user has a specific permission
export function hasPermission(permissionId) {
  const userData = getUserData();
  if (!userData || !userData.p_f_ids || !Array.isArray(userData.p_f_ids)) {
    return false;
  }
  return userData.p_f_ids.includes(permissionId);
}

// Common utility function to get user permissions array
export function getUserPermissions() {
  const userData = getUserData();
  if (!userData || !userData.p_f_ids || !Array.isArray(userData.p_f_ids)) {
    return [];
  }
  return userData.p_f_ids;
}


export const capitalizeFirstLetter = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
